import React, { useEffect } from 'react';
import Detailed from './detailed';
import { Button, Card, CardContent } from '@material-ui/core';
import { AddOutlined } from '@material-ui/icons';
import { useStyles } from './styles';
import Grid from '@material-ui/core/Grid';
import ActivityLegend from './ActivityLegend';
import { AnimalActivity } from './types';
import { ChartHelpers } from './chart-helpers';
import { useParams } from 'react-router-dom';

const DetailedList: React.FC<any> = () => {
  const classes = useStyles();

  const { locations } = useParams<{ locations: string }>();
  const locationsValue: { id: string; name: string }[] = JSON.parse(locations as string);

  const [count, setCount] = React.useState(1);
  const [activities, setActivities] = React.useState<AnimalActivity[]>([]);

  useEffect(() => {
    setActivities(ChartHelpers.getActivitiesWithColors());
  }, []);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item md={12}>
          <Card variant="elevation" elevation={1}>
            <CardContent className={classes.legendCard}>
              <ActivityLegend activities={activities} toggleActivity={setActivities} horizontal={true} />
            </CardContent>
          </Card>
        </Grid>
        {Array.from(Array(count).keys()).map((i) => {
          return (
            <Grid key={i} item md={12}>
              <Card variant="elevation" elevation={1}>
                <CardContent>
                  <Detailed activities={activities} locations={locationsValue} />
                </CardContent>
              </Card>
            </Grid>
          );
        })}
        <Grid item md={12}>
          <div className={classes.detailedListCardContainer}>
            <div className={classes.line}></div>
            <Button variant="outlined" onClick={() => setCount(count + 1)}>
              <AddOutlined />
              Add Chart
            </Button>
            <div className={classes.line}></div>
          </div>
        </Grid>
      </Grid>
    </>
  );
};
export default DetailedList;
